import { TopSpenderTable } from '../TopSpenderTable'
import { withTopCoinSpender } from './withTopCoinSpender'

const ConnectedTopCoinSpender = withTopCoinSpender(TopSpenderTable)

export { ConnectedTopCoinSpender as TopCoinSpender }
